import { useEffect, useState, useCallback, useRef } from "react";
import { styled } from "@mui/material/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsExports from "./config/aws-exports";
import "./App.css";
import * as AuthMain from "./auth/AuthMain";
import { userState } from "./interface/MainInterface";
import Header from "./mainContainer/Header";
import MainConteiner from "./mainContainer/MainConteiner";
Amplify.configure(awsExports);

let userParam: userState = {
  userId: "",
  userName: "",
  userDong: "",
  userHo: "",
  userLevel: "",
  readInputDt: "",
  userType: "",
  readAddress: "",
  isAuth: false,
};

const LayoutDivider = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  minHeight: "44px !important",
  padding: theme.spacing(0, 0),
  justifyContent: "flex-end",
}));

const theme = createTheme({
  typography: {
    fontFamily: "Pretendard, sans-serif",
  },
  palette: {
    primary: {
      main: "#2E3341",
      contrastText: "#fff",
    },
    error: {
      main: "#ff000090",
      contrastText: "#fff",
    },
  },
  zIndex: { drawer: 990, modal: 990 },
});

function App() {
  const headerRef: any = useRef();
  const [userState, setUserState] = useState<userState>();
  const [selectedMenu, setSelectedMenu] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchResult, setSearchResult] = useState<any>([]);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const winSize = isMobile ? "xs" : "lg";

  async function setUserInfo() {
    // 세션체크
    const result = AuthMain.getSession();
    if (result) {
      userParam.isAuth = true;
      // 사용자 정보 조회
      userParam.userId = result.userId;
      userParam.userName = result.userName;
      userParam.userDong = result.userDong;
      userParam.userHo = result.userHo;
      userParam.userLevel = result.userLevel;
      userParam.readInputDt = result.readInputDt;
      userParam.userType = result.userType;
      userParam.readAddress = result.readAddress;
      userParam.isAuth = true;
    }
    setUserState(userParam);
  }

  useEffect(() => {
    setUserInfo();
  }, []);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((previousIsMenuOpen) => !previousIsMenuOpen);
  }, []);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  useEffect(() => {
    closeMenu();
  }, [selectedMenu, closeMenu]);

  const getLeftCount = () => {
    headerRef.current.getLeftCount();
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        {userState !== undefined && (
          <BrowserRouter>
            {selectedMenu === "/" ||
            selectedMenu === "/signin" ||
            selectedMenu === "/signup" ||
            selectedMenu.startsWith("/member") ? (
              <></>
            ) : userState.isAuth ? (
              <>
                <Header
                  ref={headerRef}
                  userState={userState}
                  winSize={winSize}
                  selectedMenu={selectedMenu}
                  isMenuOpen={isMenuOpen}
                  toggleMenu={toggleMenu}
                  closeMenu={closeMenu}
                />
                <LayoutDivider />
              </>
            ) : (
              <></>
            )}

            <MainConteiner
              userState={userState}
              setSelectedMenu={setSelectedMenu}
              winSize={winSize}
              getLeftCount={getLeftCount}
              searchResult={searchResult}
              setSearchResult={setSearchResult}
            />
          </BrowserRouter>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
